import styled from 'styled-components/macro'

// this doesn't seem right
export const FormWrapper = styled.div`
  > div {
    margin-top: 18px;
  }
`
